import type {
    PropertyValue,
    PropertyValueList,
    PropertyValueMap
} from '@wix/ambassador-data-science-ml-framework-v1-feature-vector/types'

function buildList(data: any) {
    const result = data.map(buildValue)

    return {
        propertyValList: {
            value: result
        }
    }
}

function buildMap(data: any): PropertyValue {
    const result: Record<string, any> = {}

    for (const key of Object.keys(data)) {
        result[key] = buildValue(data[key])
    }

    return {
        propertyValMap: {
            mapVal: result
        }
    }
}

function buildPrimitive(data: any): PropertyValue {
    let key
    if (typeof data === 'boolean') {
        key = 'boolVal'
    } else if (typeof data === 'string') {
        key = 'strVal'
    } else if (typeof data === 'number') {
        if (Number.isNaN(data)) {
            key = 'longVal'
        } else if (!Number.isNaN(data)) {
            key = 'doubleVal'
        }
        // eslint-disable-next-line lodash/prefer-is-nil
    } else if (data === null || data === undefined) {
        key = null
    } else {
        const errorMessage = 'Invalid primitive value'
        throw Error(errorMessage)
    }

    return key
        ? {
              [key]: data
          }
        : {}
}

function buildValue(data: any): PropertyValue | PropertyValueList | PropertyValueMap {
    let value

    if (Array.isArray(data)) {
        value = buildList(data)
    } else if (typeof data === 'object' && data !== null) {
        value = buildMap(data)
    } else {
        value = buildPrimitive(data)
    }

    return value
}

export function composeProtoInput(data: any): PropertyValue | PropertyValueList | PropertyValueMap {
    return buildValue(data)
}

function isList(data: any) {
    return Boolean(data?.propertyValList?.value || data?.property_val_list?.value)
}

function isMap(data: any) {
    return Boolean(data?.propertyValMap?.mapVal || data?.property_val_map?.map_val)
}

function parseList(data: any) {
    const list = data.propertyValList?.value ?? data.property_val_list.value

    return list.map(parseValue)
}

function parseMap(data: any) {
    const map = data.propertyValMap?.mapVal ?? data.property_val_map.map_val
    const result: Record<string, any> = {}

    for (const key of Object.keys(map)) {
        result[key] = parseValue(map[key])
    }

    return result
}

function parsePrimitive(data: any) {
    const [value] = Object.values(data)
    return value
}

function parseValue(data: any) {
    let result

    if (isMap(data)) {
        result = parseMap(data)
    } else if (isList(data)) {
        result = parseList(data)
    } else {
        result = parsePrimitive(data)
    }

    return result
}

export function parseProtoOutput(data: any) {
    return parseValue(data)
}
